import { Icon } from '@eventbrite/eds-icon';
import { NegativeIconFill } from '@eventbrite/eds-iconography';
import { TYPE_ERROR } from '@eventbrite/eds-notification';
import { GenericLazyString } from '@eventbrite/i18n';
import React, { FunctionComponent } from 'react';
import { ParsedError } from '../../models/error';

interface ErrorNotificationProps {
    errorDescription: GenericLazyString | string | null;
    errors: Array<ParsedError> | null;
}

const mapErrorsToErrorNotifications = ({
    errorDescription,
    errors,
}: ErrorNotificationProps) => {
    const mappedErrors = errors
        ? errors.map((error) => ({
              type: TYPE_ERROR,
              description: error.errorDescription,
          }))
        : [];

    const submitFailedError = errorDescription
        ? [
              {
                  type: TYPE_ERROR,
                  description: errorDescription,
              },
          ]
        : [];

    return [...mappedErrors, ...submitFailedError];
};

const ErrorNotification: FunctionComponent<ErrorNotificationProps> = ({
    errorDescription,
    errors,
}) => {
    if (!errors?.length && !errorDescription) {
        return null;
    }

    const errorNotifications = mapErrorsToErrorNotifications({
        errorDescription,
        errors,
    });

    return (
        <div className="eds-l-mar-vert-4">
            <p className="eds-text-bm eds-text-color--error eds-align--center-vertical">
                <span className="eds-l-mar-right-1">
                    <Icon type={<NegativeIconFill />} color="ui-red" />
                </span>
                {errorNotifications.map((err, i) => (
                    <span key={i}>{err.description}</span>
                ))}
            </p>
        </div>
    );
};

export default ErrorNotification;
